<template lang="pug">
.content-center
  .overlay(@click="closeSidebar")
  //- small {{ menuX }} {{ mmoMode }} {{ menu3 }} {{ menu1}}
  template(v-if="gamesList.includes(String(menu2)) && (String(menu0) == 'all') && (String(menu1) == 'today')")
    //- small Working in progress...
    egames(:keys="marketKeys" :key1="earlyMarketKeys" :key2="todayMarketKeys" :key3="liveMarketKeys" :items="marketList")
  template(v-else)
    template(v-if="!['favorite'].includes(menu0)")
      sportsItem(
        v-if="!isWorldCupEvent"
        :order="order"
        :live="liveMenu"
        :today="todayMenu"
        :early="earlyMenu"
        :items="menu3 == 'parlay' ? parlayMenu : selectedMarket"
        :sports="menuList.sports"
        @save="saveMarket"
      )
      .worldcup-title(v-if="isWorldCupEvent")
        .icon
          img.img-fluid(src='images/worldcup.png')
        .league-title {{ $t("ui.worldcup") }}
        a.wc-info-btn(:href="worldcupPageUrl()" target="_blank") {{ $t("ui.newsinfo") }}
      sportsMarket(
        v-if="['live','upcoming','early','today'].includes(menu1)"
        :live="liveMenu"
        :today="todayMenu"
        :early="earlyMenu"
        :items="selectedMarket"
        :sports="menuList.sports"
        @setMenu1="setMarketTab"
        @setMenu3="setMenu3"
      )
      .tab-nav(v-if="['early'].includes(menu1) && !['parlay','orz'].includes(menu3) && !isWorldCupEvent")
        ul.scrolling-wrapper
          li
            a(href="javascript:void(0);" :class="{ 'active' : menu1 == 'early' && selectedDays == 0 }" @click="market('early', 0)")
              | {{ $t("ui.early_all") }}
          li(v-for="(item, index) in 7" :key="index")
            a(href="javascript:void(0);" :class="{ 'active' : menu1 == 'early' && selectedDays == item}" @click="market('early', item)")
              | {{ $dayjs().subtract(12, 'hour').add(item, 'day').format("MMM DD (ddd)") }}
      .tab-nav(v-if="['today','upcoming'].includes(menu1) && !['parlay','orz'].includes(menu3) && !isWorldCupEvent")
        ul.scrolling-wrapper
          li
            a(href='javascript:void(0);' :class="{ 'active' : ['today'].includes(menu1) }" @click="setMenu1('today')") {{ $t("ui.all") }}
          li
            a(href='javascript:void(0);' :class="{ 'active' : ['upcoming'].includes(menu1) && upcomingHours == '1' }" @click="market('upcoming', '1')") 1 {{ $t("ui.hour") }}
          li
            a(href='javascript:void(0);' :class="{ 'active' : ['upcoming'].includes(menu1) && upcomingHours == '3' }" @click="market('upcoming', '3')") 3 {{ (language == 'en') ? $t("ui.hour") + 's' : $t("ui.hour") }}
          li
            a(href='javascript:void(0);' :class="{ 'active' : ['upcoming'].includes(menu1) && upcomingHours == '6' }" @click="market('upcoming', '6')") 6 {{ (language == 'en') ? $t("ui.hour") + 's' : $t("ui.hour") }}
    .function-bar
      .function-item
        .btn-icon.fav(:class="{ 'active' : ['favorite'].includes(menu0) }" @click="toggleFavorite()")
          i.fa-solid.fa-star
        template(v-if="!['favorite'].includes(menu0) && !isEventMarket")
          .btn-parlay(:class="{ 'active' : menu3 == 'parlay' && !menuX }" @click="setMenu1('parlay')") {{ $t("ui.parlay") }}
          .btn-parlay-mmo(v-if="mmoMode && menuList.parlay_count > 0" :class="{ 'active' : menuX }" @click="setMenu0('mmoparlay')") {{ $t("ui.mmo_parlay") }}
        .btn-icon(@click="toggleSearch()")
          img(src='images/icon/others/league.svg' alt='')
        .btn-icon(v-if="!isEventMarket" @click="go('/parlaygenerator')")
          img(src='images/icon/others/parlay.svg')
      .function-item
        .btn-icon.collapse-all(onclick='toggleAll(this)')
          i.fa-solid.fa-angles-up
    .market-group
      template(v-if="marketKeys.length > 0")
        template(v-if="menuX == true")
          // MMO PARLAY ONLY
          template(v-for="(ml, mk) in liveMarketKeys")
            template(v-if="marketList[ml].xp")
              template(v-for="(ll, lk) in marketList[ml].leagueList")
                template(v-if="ll.xp")
                  .m-card(:class="leagueMarketClass(ll)")
                    league(:source="ll" :index="parseInt(lk)" :key="ll.id")
                    .collapse.show(:id="'league-' + ll.id" :aria-labelledby="ll.id")
                      template(v-for="(mml, mmk) in ll.matchList")
                        template(v-if="mml.xp")
                          SelfAwareItem(
                            v-bind="matchVirtualOpts"
                            :key="mml.id"
                          )
                            matchX(:source="mml" :index="parseInt(mmk)")
          template(v-for="(ml, mk) in todayMarketKeys")
            template(v-if="marketList[ml].xp")
              template(v-for="(ll, lk) in marketList[ml].leagueList")
                template(v-if="ll.xp")
                  .m-card(:class="leagueMarketClass(ll)")
                    league(:source="ll" :index="parseInt(lk)" :key="ll.id")
                    .collapse.show(:id="'league-' + ll.id" :aria-labelledby="ll.id")
                      template(v-for="(mml, mmk) in ll.matchList")
                        template(v-if="mml.xp")
                          SelfAwareItem(
                            v-bind="matchVirtualOpts"
                            :key="mml.id"
                          )
                            matchX(:source="mml" :index="parseInt(mmk)")
          template(v-for="(ml, mk) in earlyMarketKeys")
            template(v-if="marketList[ml].xp")
              template(v-for="(ll, lk) in marketList[ml].leagueList")
                template(v-if="ll.xp")
                  .m-card(:class="leagueMarketClass(ll)")
                    league(:source="ll" :index="parseInt(lk)" :key="ll.id")
                    .collapse.show(:id="'league-' + ll.id" :aria-labelledby="ll.id")
                      template(v-for="(mml, mmk) in ll.matchList")
                        template(v-if="mml.xp")
                          SelfAwareItem(
                            v-bind="matchVirtualOpts"
                            :key="mml.id"
                          )
                            matchX(:source="mml" :index="parseInt(mmk)")
                  //- mainItem(:source="ll" :index="parseInt(lk)" :key="ll.id")
                  //- template(v-for="(mml, mmk) in ll.matchList")
                  //-   template(v-if="mml.xp")
                  //-     mainItem(:source="mml" :index="parseInt(mmk)" :key="mml.id")
        template(v-else)
          template(v-for="(ml, mk) in liveMarketKeys")
            template(v-for="(ll, lk) in marketList[ml].leagueList")
              template(v-if="ll.betTypeId != 'orz'")
                .m-card(:class="leagueMarketClass(ll)")
                  league(:source="ll" :index="parseInt(lk)" :key="ll.id")
                  template(v-if="![40].includes(ll.sportsId)")
                    .collapse.show(:id="'league-' + ll.id" :aria-labelledby="ll.id")
                      template(v-for="(mml, mmk) in ll.matchList")
                        //- match(:source="mml" :index="parseInt(mmk)" :key="mml.id") 
                        SelfAwareItem(
                          v-bind="matchVirtualOpts"
                          :key="mml.id"
                        )
                          match(:source="mml" :index="parseInt(mmk)")
                  template(v-else)
                    MatchHDPOUMAINOdds(:source="ll")
              template(v-else)
                .m-card(:class="leagueMarketClass(ll)")
                  league(:source="ll" :index="parseInt(lk)" :key="ll.id")
                  MatchORZOdds(:source="ll")
          template(v-for="(ml, mk) in todayMarketKeys")
            template(v-for="(ll, lk) in marketList[ml].leagueList")
              template(v-if="ll.betTypeId != 'orz'")
                .m-card(:class="leagueMarketClass(ll)")
                  league(:source="ll" :index="parseInt(lk)" :key="ll.id")
                  template(v-if="![40].includes(ll.sportsId)")
                    .collapse.show(:id="'league-' + ll.id" :aria-labelledby="ll.id")
                      template(v-for="(mml, mmk) in ll.matchList")
                        SelfAwareItem(
                          v-bind="matchVirtualOpts"
                          :key="mml.id"
                        )
                          match(:source="mml" :index="parseInt(mmk)")
                  template(v-else)
                    MatchHDPOUMAINOdds(:source="ll")
              template(v-else)
                .m-card(:class="leagueMarketClass(ll)")
                  league(:source="ll" :index="parseInt(lk)" :key="ll.id")
                  MatchORZOdds(:source="ll")
          template(v-for="(ml, mk) in earlyMarketKeys")
            template(v-for="(ll, lk) in marketList[ml].leagueList")
              template(v-if="ll.betTypeId != 'orz'")
                .m-card(:class="leagueMarketClass(ll)")
                  league(:source="ll" :index="parseInt(lk)" :key="ll.id")
                  template(v-if="![40].includes(ll.sportsId)")
                    .collapse.show(:id="'league-' + ll.id" :aria-labelledby="ll.id")
                      template(v-for="(mml, mmk) in ll.matchList")
                        //- match(:source="mml" :index="parseInt(mmk)" :key="mml.id")
                        SelfAwareItem(
                          v-bind="matchVirtualOpts"
                          :key="mml.id"
                        )
                          match(:source="mml" :index="parseInt(mmk)")
                  template(v-else)
                    MatchHDPOUMAINOdds(:source="ll")
              template(v-else)
                .m-card(:class="leagueMarketClass(ll)")
                  league(:source="ll" :index="parseInt(lk)" :key="ll.id")
                  MatchORZOdds(:source="ll")
      template(v-else)
        loading(v-if="isMarketLoading")
        .no-data(v-else)
          .no-data-wrapper
            //- img(src='/images/no_data.svg?v=12')
            span.text {{ $t("error.matchHide") }}


  
</template>

<script>
import toolBar from "@/components/mobile/toolBar";
import footerNav from "@/components/mobile/footerNav";
import mainItem from "@/components/mobile/main/mainItem";
import refreshButton from "@/components/mobile/main/refreshButton";
import MatchORZOdds from "@/components/mobile/main/xmatch/matchORZOdds";
import MatchHDPOUMAINOdds from "@/components/mobile/main/xmatch/new/matchHDPOUMAINOdds";
import mixinMain from "@/library/mixinMain";
import mixinDelay from "@/library/mixinDelay";
import { EventBus } from "@/library/_event-bus.js";
import sportsItem from "@/components/mobile/main/sportsItem";
import sportsMarket from "@/components/mobile/main/sportsMarket";

import Marquee from "@/components/mobile/mainPanelControl/marquee";
import config from "@/config";

import egames from "@/components/mobile/egames";
import loading from "@/components/ui/loading";
import SelfAwareItem from "@/components/ui/SelfAwareItem.vue";
import league from "@/components/mobile/main/league";
import match from "@/components/mobile/main/match";
import matchX from "@/components/mobile/main/matchX";

/** Viewport-based row virtualization for match lists (shared IO pool in SelfAwareItem). */
const MATCH_VIRTUAL_OPTS = Object.freeze({
  viewport: true,
  estimatedHeight: 152,
  showMargin: "480px",
  hideMargin: "1200px",
  observeResize: true,
  immediate: true
});

export default {
  components: {
    loading,
    SelfAwareItem,
    toolBar,
    footerNav,
    mainItem,
    refreshButton,
    MatchORZOdds,
    MatchHDPOUMAINOdds,
    sportsItem,
    sportsMarket,
    Marquee,
    egames,
    league,
    match,
    matchX
  },
  mixins: [mixinMain, mixinDelay],
  data() {
    return {
      matchVirtualOpts: MATCH_VIRTUAL_OPTS,
      gamesList: config.gamesList,
      state: {
        GET_LIVE: false,
        GET_NONLIVE: false,
        GET_MARKET: false,
        GET_TM: false,
        INVALIDATE: false
      },
      counter: {
        GET_LIVE: 0,
        GET_NONLIVE: 0,
        GET_MARKET: 0,
        GET_TM: 0,
        INVALIDATE: 0
      },
      func: {
        GET_LIVE: null,
        GET_NONLIVE: null,
        GET_MARKET: null,
        INVALIDATE: null,
        GET_TM: null,
      }
    };
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    isNonLive() {
      if (["all"].includes(this.menu0)) {
        if (["orz", "parlay"].includes(this.menu3)) {
          return true;
        } else {
          if (["early", "parlay"].includes(this.menu1)) {
            return true;
          }
        }
      } else {
        return false;
      }
      return false;
    },
    selectedMarket() {
      // Merge all three menus (live, today, early) to show sports with matches in any category
      const merged = {};
      
      // Collect all unique sport IDs from all three menus
      const allSportIds = new Set([
        ...Object.keys(this.liveMenu || {}),
        ...Object.keys(this.todayMenu || {}),
        ...Object.keys(this.earlyMenu || {})
      ]);
      
      // For each sport, use the menu entry with the highest match count (tn)
      allSportIds.forEach(sportId => {
        const live = this.liveMenu[sportId];
        const today = this.todayMenu[sportId];
        const early = this.earlyMenu[sportId];
        
        // Priority: live > today > early (based on highest tn value)
        let best = null;
        let maxTn = 0;
        
        if (live && live.tn > maxTn) {
          best = live;
          maxTn = live.tn;
        }
        if (today && today.tn > maxTn) {
          best = today;
          maxTn = today.tn;
        }
        if (early && early.tn > maxTn) {
          best = early;
          maxTn = early.tn;
        }
        
        if (best) {
          merged[sportId] = best;
        }
      });
      
      return merged;
    },
    isMarketLoading() {
      return (
        this.loading.market ||
        this.loading.live ||
        this.loading.today ||
        this.loading.early ||
        this.state.GET_MARKET ||
        this.state.GET_LIVE ||
        this.state.GET_NONLIVE ||
        this.state.INVALIDATE
      );
    },
    /** World Cup from sidebar: setMenu0("event", "3", …) */
    isWorldCupEvent() {
      return this.menu0 === "event" && String(this.menuY) === "3";
    },
    /** Special event market (sidebar): menu0 event + menuY identifies the event */
    isEventMarket() {
      return this.menu0 === "event";
    }
  },
  destroyed() {
    EventBus.$off("GET_LIVE_COUNT", this.handleLive);
    EventBus.$off("GET_NONLIVE_COUNT", this.handleNonLive);
    EventBus.$off("GET_MARKET_COUNT", this.handleMarket);
    EventBus.$off("GET_TM_COUNT", this.handleTm);
    EventBus.$off("GET_LIVE", this.runLive);
    EventBus.$off("GET_NONLIVE", this.runNonLive);
    EventBus.$off("GET_MARKET", this.runMarket);
    EventBus.$off("GET_TM", this.runTm);
    EventBus.$off("INVALIDATE", this.runInvalidate);
  },
  mounted() {
    // $('.btn-parlay').click( function(event){
    //   event.stopPropagation();
    //   $('.parlay-dropdown-filter-menu').slideDown();
    // });
    // $('.parlay-dropdown-filter-menu .close').click( function(event){
    //   event.stopPropagation();
    //   $('.parlay-dropdown-filter-menu').slideUp();
    // });

    EventBus.$on("GET_LIVE_COUNT", this.handleLive);
    EventBus.$on("GET_NONLIVE_COUNT", this.handleNonLive);
    EventBus.$on("GET_MARKET_COUNT", this.handleMarket);
    EventBus.$on("GET_TM_COUNT", this.handleTm);
    EventBus.$on("GET_LIVE", this.runLive);
    EventBus.$on("GET_NONLIVE", this.runNonLive);
    EventBus.$on("GET_MARKET", this.runMarket);
    EventBus.$on("GET_TM", this.runTm);
    EventBus.$on("INVALIDATE", this.runInvalidate);
    this.func.GET_LIVE = this.debounce(this.getLive, 500);
    this.func.GET_NONLIVE = this.debounce(this.getNonLive, 500);
    this.func.GET_MARKET = this.debounce(this.getMarket, 500);
    this.func.GET_TM = this.debounce(this.getTM, 500);
    this.func.INVALIDATE = this.debounce(this.invalidate, 500);
    // Mixin schedules INVALIDATE after 1s; start the first fetch immediately so the loader shows
    // straight away instead of the empty "no market" state.
    if (this.invalidateTimer != null) {
      clearTimeout(this.invalidateTimer);
      this.invalidateTimer = null;
    }
    if (this.isLoggedIn) {
      EventBus.$emit("INVALIDATE");
    }
  },
  methods: {
    // Virtual league header uses the same card class in early (1), today (2), and live (3).
    leagueMarketClass(league) {
      if (!league || ![1, 2, 3].includes(league.marketId)) return "";
      return this.$store.getters.leagueKindClassOf(league.leagueId);
    },
    worldcupPageUrl() {
      const domain = config.getDomain(window.location.hostname, false);
      return "https://wbetwc.com?referer=m." + domain;
    },
    closeSidebar() {
      $('body').removeClass('open-side-nav');
    },
    runLive(e) {
      this.state.GET_LIVE = true;
      setTimeout(() => {
        this.state.GET_LIVE = false;
      }, 1000);
    },
    runNonLive(e) {
      this.state.GET_NONLIVE = true;
      setTimeout(() => {
        this.state.GET_NONLIVE = false;
      }, 2000);
    },
    runMarket(e) {
      this.state.GET_LIVE = true;
      this.state.GET_NONLIVE = true;
      this.state.GET_MARKET = true;
      this.state.GET_TM = true;
      setTimeout(() => {
        this.state.GET_LIVE = false;
        this.state.GET_NONLIVE = false;
        this.state.GET_MARKET = false;
        this.state.GET_TM = false;
      }, 3000);
    },
    runInvalidate(e) {
      this.state.GET_LIVE = true;
      this.state.GET_NONLIVE = true;
      this.state.GET_MARKET = true;
      this.state.GET_TM = true;
      this.state.INVALIDATE = true;
      setTimeout(() => {
        this.state.GET_LIVE = false;
        this.state.GET_NONLIVE = false;
        this.state.GET_MARKET = false;
        this.state.GET_TM = false;
        this.state.INVALIDATE = false;
      }, 5000);
    },
    runTm(e) {
      this.state.GET_TM = true;
      setTimeout(() => {
        this.state.GET_TM = false;
      }, 3000);
    },
    handleLive(e) {
      this.counter.GET_LIVE = e;
    },
    handleNonLive(e) {
      this.counter.GET_NONLIVE = e;
    },
    handleMarket(e) {
      this.counter.GET_MARKET = e;
    },
    handleTm(e) {
      this.counter.GET_TM = e;
    },
    getLive() {
      EventBus.$emit("GET_LIVE");
    },
    getNonLive() {
      EventBus.$emit("GET_NONLIVE");
    },
    getMarket() {
      EventBus.$emit("GET_MARKET");
    },
    getTM(e) {
      EventBus.$emit("GET_TM", e);
    },
    invalidate() {
      EventBus.$emit("INVALIDATE");
    },
    clearSearch() {
      this.$store.dispatch("layout/setSearch", null);
    },
    resetSelectLeague() {
      var elem = $(".btn-collapse");
      if (elem.hasClass("close-all")) {
        elem.removeClass("close-all");
        elem.addClass("open-all");
      }
      this.$store.dispatch("layout/resetSelectLeague");
    },
    setDays(e) {
      if (config.day1.includes(e)) {
        this.$store.dispatch("layout/setSelectedDays", "1");
      } else {
        this.$store.dispatch("layout/setSelectedDays", "0");
      }
    },
    go(e) {
      this.$router.push(e).catch(err => {});
    },
    getMenu(e) {
      if (!this.menuList) {
        return {};
      }

      if (!this.menuList.menu) {
        return {};
      }

      switch (e) {
        case "early":
          if (this.menuList.menu["1"]) return this.menuList.menu["1"];
          else return {};
        case "today":
          if (this.menuList.menu["2"]) return this.menuList.menu["2"];
          else return {};
        case "live":
          if (this.menuList.menu["3"]) return this.menuList.menu["3"];
          else return {};
        case "parlay":
          if (this.menuList.menu["4"]) return this.menuList.menu["4"];
          else return {};
        default:
          return {};
      }
    },
    setMenu(e, options = {}) {
      // Handle outright (orz) case - redirect to setOutright
      if (e === 'orz') {
        this.setOutright();
        return;
      }

      // Options: { isMmoParlay: false, parlayType: 'parlay' }
      const isMmoParlay = options.isMmoParlay || false;
      const parlayType = options.parlayType || 'parlay';
      const parlayButton = isMmoParlay ? '.btn-parlay-mmo' : '.btn-parlay';
      const cancelParlayMethod = isMmoParlay ? 'cancelParlayMMO' : 'cancelParlay';

      this.$store.dispatch("layout/setSelectedMatch", null);

      var mi5 = {};
      let menuX = false;

      // Handle parlay toggle
      if (e === parlayType) {
        $(parlayButton).toggleClass("active");
        if ($(parlayButton).hasClass("active")) {
          if (isMmoParlay) {
            menuX = true;
          }
          this.$store.dispatch("layout/setOptions", { property: "parlay", value: this.menu2 });
        } else {
          if (EventBus[cancelParlayMethod]) {
            EventBus[cancelParlayMethod]();
          }
          this.$store.dispatch("layout/setOptions", { property: "parlay", value: "" });
          e = "today";
        }
      } else {
        if (EventBus[cancelParlayMethod]) {
          EventBus[cancelParlayMethod]();
        }
        this.$store.dispatch("layout/setOptions", { property: "parlay", value: "" });
        $(parlayButton).removeClass("active");
      }

      mi5["menuX"] = menuX;
      mi5["menuY"] = "0";
      mi5["menu1"] = e;
      mi5["menu2"] = this.menu2;

      const persistSpecialEvent =
        this.menu0 === "event" && String(this.menuY) !== "0";

      // Determine menu configuration based on type
      switch (e) {
        case "live":
          mi5["menu0"] = "live";
          mi5["menu3"] = "hdpou";
          var newLive = {};
          newLive[parseInt(this.menu2)] = true;
          this.$store.dispatch("layout/setOptions", { property: "live", value: newLive });
          break;
        case "mmoparlay":
          mi5["menu0"] = "parlay";
          mi5["menu2"] = 1; // Force parlay mode to soccer always
          mi5["menu3"] = "parlay";
          break;
        case "parlay":
          mi5["menu0"] = "all";
          mi5["menu1"] = "today";
          mi5["menu3"] = "parlay";
          break;
        default:
          // Keep current sport when switching markets (today/early)
          // Only validate if the sport exists in the selected menu
          var menu = this.getMenu(e);
          var sports = Object.keys(menu);
          var choosenSport = this.menu2 != null ? this.menu2.toString() : "1";
          
          // Only switch sport if current sport doesn't exist in any menu (live, today, early)
          // and the selected menu has available sports
          if (!sports.includes(choosenSport) && sports.length > 0) {
            // Check if current sport exists in other menus before switching
            const hasLive = this.liveMenu[choosenSport] && this.liveMenu[choosenSport].tn > 0;
            const hasToday = this.todayMenu[choosenSport] && this.todayMenu[choosenSport].tn > 0;
            const hasEarly = this.earlyMenu[choosenSport] && this.earlyMenu[choosenSport].tn > 0;
            
            // Only switch if sport doesn't exist in any menu
            if (!hasLive && !hasToday && !hasEarly) {
              choosenSport = sports[0];
            }
            // Otherwise keep current sport even if not in selected menu
          }
          
          mi5["menu0"] = "all";
          mi5["menu2"] = parseInt(choosenSport);
          mi5["menu3"] = "hdpou";
          break;
      }

      if (
        persistSpecialEvent &&
        !["parlay", "mmoparlay"].includes(e)
      ) {
        mi5["menu0"] = "event";
        mi5["menuY"] = String(this.menuY);
      }

      // Switch the resolved today market over to the upcoming-hours filter, same shape as market("upcoming", d).
      // The helper re-checks the day and skips gamesList sports, which render the egames layout on all/today only.
      if (options.useUpcomingHours) {
        config.applyWeekendTodayMarket(mi5, this.$dayjs().day(), this.$store);
      }

      // Check if any menu values have changed
      var changed = false;
      if (mi5["menuX"] != this.menuX) {
        changed = true;
      }
      if (mi5["menu0"] != this.menu0) {
        changed = true;
      }
      if (mi5["menu1"] != this.menu1) {
        changed = true;
      }
      if (mi5["menu2"] != this.menu2) {
        changed = true;
      }
      if (mi5["menu3"] != this.menu3) {
        changed = true;
      }

      if (changed) {
        this.setDays(parseInt(mi5["menu2"]));
        this.resetSelectLeague();
        this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }
    },
    setMenu0(e) {
      this.setMenu(e, { isMmoParlay: true, parlayType: 'mmoparlay' });
    },
    setMenu1(e) {
      this.setMenu(e, { isMmoParlay: false, parlayType: 'parlay' });
    },
    // Not a computed: $dayjs() is not reactive, so a cached value would go stale past midnight
    isTodayUpcomingDay() {
      return config.todayUpcomingDays.includes(this.$dayjs().day());
    },
    // Market tab strip: "Today" opens on the upcoming-hours filter on the days listed in
    // config.todayUpcomingDays. The "All" sub-tab still calls setMenu1("today") for the full list.
    setMarketTab(e) {
      if (e === "today") {
        this.setMenu("today", { isMmoParlay: false, parlayType: 'parlay', useUpcomingHours: this.isTodayUpcomingDay() });
        return;
      }
      this.setMenu1(e);
    },
    setMenu3(e, f) {
      this.$store.dispatch("layout/setSelectedMatch", null);

      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      mi5["menu1"] = e;
      mi5["menu2"] = this.menu2;
      switch (e) {
        case "live":
          mi5["menu0"] = "live";
          mi5["menu3"] = "hdpou";
          var newLive = {};
          newLive[parseInt(this.menu2)] = true;
          this.$store.dispatch("layout/setOptions", { property: "live", value: newLive });
          break;
        case "parlay":
          mi5["menu0"] = "all";
          mi5["menu1"] = f;
          mi5["menu3"] = "parlay";
          break;
        default:
          var menu = this.getMenu(e);
          var sports = Object.keys(menu);
          var choosenSport = "1";
          if (this.menu2 != null) {
            choosenSport = this.menu2.toString();
          }
          if (!sports.includes(choosenSport)) {
            choosenSport = sports[0];
          }
          mi5["menu0"] = "all";
          mi5["menu2"] = parseInt(choosenSport);
          mi5["menu3"] = "hdpou";
          break;
      }

      const persistEventMenu3 =
        this.menu0 === "event" && String(this.menuY) !== "0" && e !== "parlay";
      if (persistEventMenu3) {
        mi5["menu0"] = "event";
        mi5["menuY"] = String(this.menuY);
      }

      var changed = true;
      if (mi5["menuX"] != this.menuX) {
        changed = true;
      }
      if (mi5["menu0"] != this.menu0) {
        changed = true;
      }
      if (mi5["menu1"] != this.menu1) {
        changed = true;
      }
      if (mi5["menu2"] != this.menu2) {
        changed = true;
      }
      if (mi5["menu3"] != this.menu3) {
        changed = true;
      }
      if (changed) {
        this.setDays(parseInt(mi5["menu2"]));
        this.resetSelectLeague();
        this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }
    },
    market(e, d) {
      this.$store.dispatch("layout/setSelectedMatch", null);
      if(e != "parlay") {
        $(".btn-parlay").removeClass("active");
      }
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      switch (e) {
        case "live":
          this.$store.dispatch("layout/setSelectedDays", "1");
          mi5["menu0"] = "live";
          mi5["menu1"] = "live";
          mi5["menu3"] = "hdpou";
          break;
        case "today":
          this.$store.dispatch("layout/setSelectedDays", "1");
          mi5["menu0"] = "all";
          mi5["menu1"] = "today";
          mi5["menu3"] = "hdpou";
          break;
        case "early":
          this.$store.dispatch("layout/setSelectedDays", d.toString());
          mi5["menu0"] = "all";
          mi5["menu1"] = "early";
          mi5["menu3"] = "hdpou";
          break;
        case "upcoming":
          this.$store.dispatch("layout/setUpcomingHours", d.toString());
          var newLive = {};
          newLive[parseInt(this.menu2)] = true;
          this.$store.dispatch("layout/setOptions", { property: "live", value: newLive });
          mi5["menu0"] = "upcoming";
          mi5["menu1"] = "upcoming";
          mi5["menu3"] = "hdpou";
          break;
        case "parlay":
          this.$store.dispatch("layout/setSelectedDays", d.toString());
          mi5["menu0"] = "all";
          mi5["menu1"] = "early";
          mi5["menu3"] = "parlay";
          break;
      }

      const persistEventMarket =
        this.menu0 === "event" &&
        String(this.menuY) !== "0" &&
        e !== "parlay";
      if (persistEventMarket) {
        mi5["menu0"] = "event";
        mi5["menuY"] = String(this.menuY);
      }

      var changed = true;
      if (mi5["menuX"] != this.menuX) {
        changed = true;
      }
      if (mi5["menu0"] != this.menu0) {
        changed = true;
      }
      if (mi5["menu1"] != this.menu1) {
        changed = true;
      }
      if (mi5["menu2"] != this.menu2) {
        changed = true;
      }
      if (mi5["menu3"] != this.menu3) {
        changed = true;
      }

      if (changed) {
        // this.resetSelectLeague();
        // this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }
    },
    setOutright() {
      this.$store.dispatch("layout/setSelectedMatch", null);
      this.resetSelectLeague();
      this.clearSearch();
      var mi5 = {};
      mi5["menuX"] = false;
      const inSpecialEvent =
        this.menu0 === "event" && String(this.menuY) !== "0";
      if (inSpecialEvent) {
        mi5["menuY"] = String(this.menuY);
        mi5["menu0"] = "event";
      } else {
        mi5["menuY"] = "0";
        mi5["menu0"] = "all";
      }
      mi5["menu1"] = "today";
      mi5["menu2"] = this.menu2;
      mi5["menu3"] = "orz";
      this.$store.dispatch("layout/setMenuItems", mi5);
      EventBus.$emit("INVALIDATE", mi5);
    },
    toggleSearch() {
      this.$store.dispatch("layout/setSelectedMatch", null);
      this.$router.push("/select_league").catch(err => {});
    },
    toggleFavorite() {
      this.$store.dispatch("layout/setSelectedMatch", null);
      if (this.menu0 != "favorite") {
        this.resetSelectLeague();
        this.clearSearch();
        var mi5 = {};
        mi5["menuX"] = false;
        mi5["menuY"] = "0";
        mi5["menu0"] = "favorite";
        mi5["menu1"] = "today";
        mi5["menu3"] = "hdpou";
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      } else {
        this.resetSelectLeague();
        this.clearSearch();
        var mi5 = {};
        mi5["menuX"] = false;
        mi5["menuY"] = "0";
        mi5["menu0"] = "all";
        mi5["menu1"] = "today";
        mi5["menu3"] = "hdpou";
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }
    },
    toggleAll() {
      var elem = $(".btn-collapse");
      if (elem.hasClass("close-all")) {
        // open
        elem.removeClass("close-all");
        elem.addClass("open-all");
        setTimeout(() => {
          $(".collapse").addClass("show");
          $(".collapse-head").removeClass("collapsed").attr("aria-expanded", "true");
        }, 100);
      } else {
        // close
        elem.removeClass("open-all");
        elem.addClass("close-all");
        setTimeout(() => {
          $(".collapse").removeClass("show");
          $(".collapse-head").addClass("collapsed").attr("aria-expanded", "false");
        }, 100);
      }
    },
    saveLive(e) {
      this.resetSelectLeague();
      this.clearSearch();
      for (var i = 0; i < config.gamesList.length; i++) {
        e[config.gamesList[i]] = false;
      }
      this.$store.dispatch("layout/setOptions", { property: "live", value: e });
      EventBus.$emit("INVALIDATE");
    },
    saveToday(e) {
      this.resetSelectLeague();
      this.clearSearch();
      this.$store.dispatch("layout/setOptions", { property: "live", value: e });
      // this.market("upcoming", this.upcomingHours);
      // EventBus.$emit("INVALIDATE");
    },
    saveParlay(e) {
      this.resetSelectLeague();
      this.clearSearch();
      for (var i = 0; i < config.gamesList.length; i++) {
        e[config.gamesList[i]] = false;
      }
      this.$store.dispatch("layout/setOptions", { property: "parlay", value: e });
      // EventBus.$emit("INVALIDATE");
    },
    saveMarket(e) {
      if(this.menu3 != "parlay") {
        if(this.menu1 == "live") {
          this.saveLive(e);
        } else {
          this.saveToday(e);
        }
      } else {
        this.saveParlay(e);
      }
    }
  }
};
</script>
